<mat-toolbar color="accent">Edit Campaign Settings</mat-toolbar>

<mat-dialog-content class="!text-black">
  <pr-campaign-settings-form
    #settingsForm
    [formValue]="data.campaign"
    (formValueChange)="formValue.set($event)"
  />
</mat-dialog-content>

<mat-dialog-actions class="!border-slate-50">
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!settingsForm.form.valid"
    (click)="submit()"
  >
    Save
  </button>
</mat-dialog-actions>
